import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import { useCommand, useSelector } from '@tdp/core';
import {
  Group,
  Metric,
  AnalyticsV2WidgetLoadingState,
  IDependencyFilters,
  IAnalyticsWidgetState,
  appDetailsSlice,
  GroupName,
  analyticsWidgetsSlice,
  analyticsV2MetricsSlice,
} from '@tdp/modules/apps';

export interface IAnalyticsUsageDataHook {
  key: keyof IAnalyticsWidgetState;
  groupName: GroupName;
  dependencyFilters: IDependencyFilters;
  groups: Group[];
  metric: Metric[];
}

export const useAnalyticsData = (params: IAnalyticsUsageDataHook) => {
  const dispatch = useDispatch();
  const { appId } = useParams();
  const filters = useSelector((state) => state.analyticsFilter.filters);
  const data = useSelector((state) => state.analyticsWidgets[params.key]);
  const getAnalyticsV2Data = useCommand(
    (commands) => commands.analyticsCommands.getAnalyticsV2Data
  );


  const app = useSelector(
    (s) => appDetailsSlice.selectors.getAppById(s, appId ?? "")
  );

  const shouldRefreshWidget = () => {
    let shouldRefresh = false;
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    params.dependencyFilters.entityType &&
      (shouldRefresh = filters.entityType !== data.filter.entityType);
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    params.dependencyFilters.os &&
      (shouldRefresh = shouldRefresh || filters.os !== data.filter.os);
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    params.dependencyFilters.area &&
      (shouldRefresh = shouldRefresh || filters.area !== data.filter.area);
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    params.dependencyFilters.platform &&
      (shouldRefresh =
        shouldRefresh || filters.platform !== data.filter.platform);
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    params.dependencyFilters.host &&
      (shouldRefresh = shouldRefresh || filters.host !== data.filter.host);
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    params.dependencyFilters.capability &&
      (shouldRefresh =
        shouldRefresh || filters.capability !== data.filter.capability);
    return shouldRefresh;
  };

  useEffect(() => {
    if (shouldRefreshWidget()) {
      dispatch(
        analyticsWidgetsSlice.actions.refreshWidget({ key: params.key, filter: filters })
      );
      // Removing the old metrics data since filters are renewed
      // dispatch(
      //   analyticsV2MetricsSlice.actions.resetMetricsData()
      // );
      // dispatch(analyticsV2MetricsSlice.actions.removeMetricsByGroupName(params.groupName));
      dispatch(analyticsV2MetricsSlice.actions.removeMetricsByGroupNameAndMetricTypes({ groupName: params.groupName, metricTypes: params.metric }));
      // dispatch(analyticsWidgetsSlice.actions.resetWidgets());
    }
  }, [filters]);

  useEffect(() => {
    if (app && (
      data.status === AnalyticsV2WidgetLoadingState.Refreshing ||
      data.status === AnalyticsV2WidgetLoadingState.NotLoaded
    )
    ) {
      getAnalyticsV2Data({
        appId: app.teamsAppId,
        filters,
        params,
      });
    }
  }, [data.status, app, filters]);
};
